import './ChoiceListItem.css';
export default {
    "root": "ChoiceListItem_root__1vtq3",
    "choice": "ChoiceListItem_choice__1vtq3",
    "control": "ChoiceListItem_control__1vtq3",
    "label": "ChoiceListItem_label__1vtq3",
    "small": "ChoiceListItem_small__1vtq3",
    "large": "ChoiceListItem_large__1vtq3",
    "helperText": "ChoiceListItem_helperText__1vtq3"
};
